import { gql } from '@/features/graphql/generated'

export const AddressSuggestionFiltersQuery = gql(/* GraphQL */ `
    query AddressSuggestionFilters {
        addressSuggestionFilters {
            geoApiFilter
        }
    }
`)

export const CustomerLookupQuery = gql(/* GraphQL */ `
    query CustomerLookup($phoneNumber: String, $name: String) {
        customers(phoneNumber: $phoneNumber, name: $name) {
            uuid
            name
            names
            phoneNumber
            phoneNumbers
            addresses {
                uuid
                street
                city
                zip
                lat
                lng
            }
        }
    }
`)

export const LocationEvaluation = gql(/* GraphQL */ `
    query LocationEvaluation($coordinates: CoordinatesInput!) {
        locationEvaluation(coordinates: $coordinates) {
            ... on DeliverableLocationEvaluationResult {
                deliverable
                zoneName
            }
            ... on NonDeliverableLocationEvaluationResult {
                deliverable
            }
        }
    }
`)
